import React from "react";

export const OnAnswerUpdateContext = React.createContext<() => void>(undefined);

export function useOnAnswerUpdate() {
  return React.useContext(OnAnswerUpdateContext);
}
